import { render, staticRenderFns } from "./AggRetencionesComponent.vue?vue&type=template&id=382e4962&"
import script from "./AggRetencionesComponent.vue?vue&type=script&lang=js&"
export * from "./AggRetencionesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports